import {
  CurrencyInput,
  Grid,
  TextFielDecimalNumbers,
  Typography,
} from "../../../../components";
import {
  formatPrecisaoFloat,
  formatPrice,
  unformatPrice,
} from "../../../../utils";
import {
  calculaSubtotalProdutos,
  calculoDesconto,
  formatProdutosTotalizadores,
  totalCompra,
} from "../add-nf-entrada";

const ResumoTotal = ({
  nfEntradaId,
  nfEntrada,
  setNfEntrada,
  nfEntradaItens,
  setNfEntradaItens,
  nfEntradaTributos,
  abaValue,
  nfEntradaPagamentos,
  setNfEntradaPagamentos,
  setGerarPagamentos,
  resumoTotalizadores,
  setResumoTotalizadores,
}) => {
  const sincronizarTotalCompra = (nfEntradaBase, listaItensAtualizada) => {
    const nfEntradaTemp = {
      ...nfEntradaBase,
      totalCompra: totalCompra(
        nfEntradaBase,
        listaItensAtualizada,
        nfEntradaTributos,
      ),
    };
    if (nfEntradaPagamentos?.length) {
      setNfEntradaPagamentos([]);
      nfEntradaTemp.totalPagamentos = 0;
    }
    setGerarPagamentos({
      valorTitulo:
        nfEntradaTemp.totalCompra - (nfEntradaTemp.totalPagamentos || 0),
    });
    setNfEntrada(nfEntradaTemp);
  };

  const handleInputAcrescimo = (event) => {
    const name = "acrescimo";
    const valor = Number(unformatPrice(event.target.value)) ?? 0;
    const totalNota = totalCompra(
      nfEntrada,
      nfEntradaItens,
      nfEntradaTributos,
      name,
    );
    const listItensAcrescimo = formatProdutosTotalizadores(
      name,
      nfEntradaItens,
      valor,
      totalNota,
    );
    setResumoTotalizadores((prevState) => ({
      ...prevState,
      [event.target.name]: valor,
    }));
    setNfEntradaItens(listItensAcrescimo);
    sincronizarTotalCompra(nfEntrada, listItensAcrescimo);
  };

  const handleInputDespesas = (event) => {
    const name = "despesas";
    const valor = Number(unformatPrice(event.target.value)) ?? 0;
    const totalNota = totalCompra(
      nfEntrada,
      nfEntradaItens,
      nfEntradaTributos,
      name,
    );
    const listItensDespesas = formatProdutosTotalizadores(
      name,
      nfEntradaItens,
      valor,
      totalNota,
    );
    setResumoTotalizadores((prevState) => ({
      ...prevState,
      [event.target.name]: valor,
    }));
    setNfEntradaItens(listItensDespesas);
    sincronizarTotalCompra(nfEntrada, listItensDespesas);
  };

  const handleInputDesconto = (event) => {
    if (nfEntradaItens?.length) {
      const name = "desconto";
      const valor = unformatPrice(event.target.value);
      if (
        parseFloat(nfEntrada[event.target.name].toFixed(2)) !==
        formatPrecisaoFloat(parseFloat(valor))
      ) {
        const totalNota = totalCompra(
          nfEntrada,
          nfEntradaItens,
          nfEntradaTributos,
          name,
        );
        const nfEntradaTemp = {
          ...nfEntrada,
          [event.target.name]: parseFloat(valor) || 0,
        };
        let listItensDesconto;
        if (event.target.name === "subtotalDesconto") {
          nfEntradaTemp.subtotalDescontoPorcentagem = calculoDesconto(
            nfEntradaItens,
            nfEntradaTemp,
            false,
          );
          listItensDesconto = formatProdutosTotalizadores(
            name,
            nfEntradaItens,
            valor,
            totalNota,
          );
        } else {
          nfEntradaTemp.subtotalDesconto = calculoDesconto(
            nfEntradaItens,
            nfEntradaTemp,
          );
          listItensDesconto = formatProdutosTotalizadores(
            name,
            nfEntradaItens,
            nfEntradaTemp?.subtotalDesconto,
            totalNota,
          );
        }
        setNfEntradaItens(listItensDesconto);
        setResumoTotalizadores(nfEntradaTemp);
        sincronizarTotalCompra(nfEntradaTemp, listItensDesconto);
      }
    }
  };

  const nextFocusInput = (event) => {
    if (event.keyCode === 13) {
      const { form } = event.target;
      const arrayInput = Array.from(form.elements).filter(
        (element) => element.tagName == "INPUT",
      );
      const index = arrayInput.indexOf(event.target);
      let element = arrayInput[index + 1];
      if (element?.disabled) {
        element = arrayInput[index + 2];
      }
      if (element) {
        element.focus();
      } else {
        arrayInput[index].blur();
      }
      event.preventDefault();
    }
  };

  return (
    <form>
      <Grid container spacing={2} justifyContent="center" className="mx-3">
        <Grid item xs={2} className="d-flex align-items-center">
          <span className="me-2">Subtotal:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(calculaSubtotalProdutos(nfEntradaItens)) ||
                "R$ 0,00"}
            </Typography>
          </span>
        </Grid>
        <Grid item xs={3.5} className="d-flex align-items-center">
          <span className="me-2">Desconto:</span>
          <TextFielDecimalNumbers
            id="subtotalDescontoPorcentagem"
            name="subtotalDescontoPorcentagem"
            variant="outlined"
            disabled={nfEntradaId || abaValue !== 0 || !nfEntradaItens.length}
            margin="none"
            size="small"
            value={resumoTotalizadores?.subtotalDescontoPorcentagem}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
          <CurrencyInput
            id="subtotalDesconto"
            name="subtotalDesconto"
            variant="outlined"
            disabled={nfEntradaId || abaValue !== 0 || !nfEntradaItens.length}
            className="px-1"
            margin="none"
            size="small"
            value={resumoTotalizadores?.subtotalDesconto}
            onBlur={handleInputDesconto}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid item xs={2.25} className="d-flex align-items-center">
          <span className="me-2">Acréscimo:</span>
          <CurrencyInput
            id="subtotalAcrescimo"
            name="subtotalAcrescimo"
            variant="outlined"
            disabled={nfEntradaId || abaValue !== 0 || !nfEntradaItens.length}
            margin="none"
            size="small"
            value={resumoTotalizadores?.subtotalAcrescimo}
            onBlur={handleInputAcrescimo}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid item xs={2.25} className="d-flex align-items-center">
          <span className="me-2">Despesas:</span>
          <CurrencyInput
            id="subtotalDespesas"
            name="subtotalDespesas"
            variant="outlined"
            disabled={nfEntradaId || abaValue !== 0 || !nfEntradaItens.length}
            margin="none"
            size="small"
            value={resumoTotalizadores?.subtotalDespesas}
            onBlur={handleInputDespesas}
            onKeyDown={nextFocusInput}
          />
        </Grid>
        <Grid
          item
          xs={2}
          className="d-flex align-items-center justify-content-center"
        >
          <span className="me-2">Total:</span>
          <span className="badge bg-primary bg-gradient bg-gradient text-wrap p-2">
            <Typography color="white" style={{ fontWeight: 700 }}>
              {formatPrice(
                totalCompra(nfEntrada, nfEntradaItens, nfEntradaTributos),
              ) || "R$ 0,00"}
            </Typography>
          </span>
        </Grid>
      </Grid>
    </form>
  );
};

export default ResumoTotal;
